import { toast } from "react-toastify";
import api from "../../Utils/api";

export default function Unavailability({ unavailabilities, getSchedule }) {
  const deleteUnavailable = async (id) => {
    const res = await api.delete(`/unavailable/${id}`);
    if (res.data.success) {
      toast.success(res.data.message);
      getSchedule();
    }
  };

  return (
    <div className="p-6">
      {/* Work Details Card */}
      <section className="bg-white mb-16">
        <h2 className="text-gray-800 font-semibold text-lg mb-4">
          Unavailabilities
        </h2>
        <hr className="w-full mb-2 mt-2" />

        {unavailabilities?.map((item) => {
          const start = new Date(item.startTime);
          const end = new Date(item.endTime);

          // Calculate days difference (inclusive)
          const msPerDay = 24 * 60 * 60 * 1000;
          const days = Math.round((end - start) / msPerDay) + 1;

          // Format dates, e.g. "Mon 21 Apr 2025"
          const formatDate = (date) =>
            date.toLocaleDateString("en-US", {
              weekday: "short",
              day: "2-digit",
              month: "short",
              year: "numeric",
            });

          const startFormatted = formatDate(start);
          const endFormatted = formatDate(end);

          return (
            <div
              key={item._id}
              className="bg-gray-50 p-4 relative w-full mb-4 rounded shadow-sm"
            >
              <div className="flex justify-between items-center mb-2">
                <h3 className="text-gray-800 font-semibold">
                  {days} DAY{days > 1 ? "S" : ""}
                </h3>
                <button
                  className="text-red-500 text-sm hover:underline"
                  onClick={() => deleteUnavailable(item._id)}
                  type="button"
                >
                  Remove
                </button>
              </div>
              <div className="">
                <p className="text-gray-700 text-sm mb-2">
                  {startFormatted} &rarr; {endFormatted}
                </p>
              </div>
            </div>
          );
        })}
      </section>
    </div>
  );
}
